export { default } from './payment-psd2-banner'; 